import { IEventGood, IEventSeats } from 'meta/pages/event'
import { TicketFee } from 'meta/pages/tickets'
import { IEventData } from 'meta/pages/v4/event'

type FeesState = {
  events: Record<string, Array<TicketFee>> // record of ticket fees by code url
  visibleEventCodeUrl?: string // code url of event fees currently displayed
  visibleEventTypeTicketCollectionId?: string
}

type GoodsState = {
  events: Record<string, Array<IEventGood>>
  visibleEventCodeUrl?: string
  visibleEventTypeTicketCollectionId?: string
}

type BulkEventsState = {
  locationIds: Record<string, number[]>
}

type EventsState = {
  events: Record<string, IEventData>
  bulk: BulkEventsState
}

export type EventState = {
  fees: FeesState
  goods: GoodsState
  seats: Record<string, IEventSeats>
  isEventFree: boolean
  isEventEnded?: boolean
  metadata?: object
  data: EventsState
}

export const initialState: EventState = {
  fees: { events: {} },
  goods: { events: {} },
  seats: {},
  isEventFree: false,
  isEventEnded: undefined,
  metadata: undefined,
  data: {
    bulk: { locationIds: {} },
    events: {},
  },
}
